export default "__VITE_ASSET__DTOhxed1__"